import { render, staticRenderFns } from "./Frequentques.vue?vue&type=template&id=1045e5c3&scoped=true&"
import script from "./Frequentques.vue?vue&type=script&lang=js&"
export * from "./Frequentques.vue?vue&type=script&lang=js&"
import style0 from "./Frequentques.vue?vue&type=style&index=0&id=1045e5c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045e5c3",
  null
  
)

export default component.exports